import { render, staticRenderFns } from "./Rule_Bingo2.vue?vue&type=template&id=0bcf5d6d&"
import script from "./Rule_Bingo2.vue?vue&type=script&lang=js&"
export * from "./Rule_Bingo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports